'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _JacketView = require('./JacketView');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_JacketView).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/JacketView/index.js
// module id = 260
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16